export function removeItemAtIndex(index:number, arr:any[]){
	return arr.filter((_x, idx) => idx !== index)
}
